<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="generateQrCodeModal"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <div class="col-sm-2 col-md-2 col-md-offset-10">
            <v-btn
              flat
              @click="generator()"
              class="close"
              id="close-button"
            >&times;</v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <div id="printArea">
              <div
                v-for="(qr, index) in qrCodeValues"
                :key="index"
                class="barcode-row"
                :style="qr[7] == 2 ? 'border: 3px solid #000; border-radius: 6px' : ''"
              >
                <div class="item col-xs-9">
                  <p><b>Order ID: </b>{{ qr[4] }}</p>
                  <p><b>QR ID: </b>{{ qr[0] }}</p>
                  <!-- <p><b>Customer ID: </b>{{ qr[3] }}</p> -->
                  <p class="customer-name"><b>Name: </b>{{ qr[1] }}</p>
                  <p><b>Mobile: </b>{{ qr[2] }}</p>
                  <!-- <p><b>Branch: </b>{{ qr[6] }}</p> -->
                </div>
                <div class="col-xs-3">
                  <qr-code
                    :text="qr[0].toString()"
                    :size="65"
                  ></qr-code>
                  <div
                    v-if="qr[5] === '1' "
                    style="border: 2px solid black; border-radius: 4px; font-size: 11px; text-transform: uppercase; font-weight: bold"
                    class="mt-1 text-center"
                  >
                    Ship only
                  </div>
                </div>
                <div style="page-break-before: always"></div>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="print-button"
            @click="printMe()"
            style="height:auto"
            outline
            color="primary"
          >Print</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import print from 'print-js'

export default {
  props: [
    'generateQrCodeModal',
    'closeGenerateQrCodeModal',
    'qrCodeValues',
    'generateQrCode',
    'getResults'
  ],

  data() {
    return {
      size: 60,
      generateQrCodeUrl: 'api/generate_qrcode'
    }
  },

  methods: {
    generator() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.generateQrCodeUrl, this.qrCodeValues, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          this.getResults()
          this.closeGenerateQrCodeModal()
        })
    },

    printMe() {
      let btnPrint = document.getElementById('print-button')
      let closePrint = document.getElementById('close-button')

      btnPrint.style.display = 'none'
      closePrint.style.display = 'none'

      setTimeout(function () {
        printJS({
          printable: 'printArea',
          type: 'html',
          targetStyles: ['*']
        })
      }, 1000)

      btnPrint.style.display = 'block'
      closePrint.style.display = 'block'

      // printJS({
      //     printable: 'print-area',
      //     type: 'html',
      //     documentTitle: '',
      //     targetStyles: ['*'],
      //     maxWidth: '76.20mm'
      // })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  overflow-y: auto !important;
  overflow-x: hidden;
}

.barcode-row {
  width: 90mm;
  height: 45mm;
  padding: 20px 0px;
  margin-bottom: 3px;
}
.barcode-row:not(:first-child) {
  padding-top: 20px;
}

.item p {
  margin: 0px 0px;
  font-size: 16px !important;
  line-height: 2.2rem !important;
}

.customer-name {
  white-space: pre-wrap;
}

#printArea {
  position: relative;
  top: 50%;
  background-color: white;
}

/*table {*/
/*page-break-inside:auto*/
/*}*/

/*tr {*/
/*page-break-inside:avoid; page-break-after:auto*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/createQrCode.vue